export default {
  emptyTable: 'w-full h-64 bg-white',
  tableBg: 'bg-[#F2F6F8]!',
  marginOverride: 'mb-1 text-[16px] font-normal text-[#123B50]',
  tableRow:
    ' border-t border-[#ccc] bg-[#F2F6F8]! nth-1:border-none! align-sub!',
  deleteIcon: 'text-[#B00020] cursor-pointer',
  tableFooter:
    'text-base font-normal font-weight-700 leading-20.02 tracking-0.17 text-black',
  tableFooterRow: 'border-t-2! border-[#ccc]! bg-[#F2F6F8]!',
  addIcon: 'text-[#0070A2] cursor-pointer',
  checkboxContainer: 'flex! items-center! flex-wrap! relative! top-[8px]!',
  blackText: 'text-[#000000]',
  greyText: 'text-[#606060]',
  addButton: 'text-[#0070A2]! ml-1!',
  carrierLTLBox:
    'bg-[#248670] font-light! text-white text-sm! rounded-sm flex justify-center items-center',
  carrierMcDotText: 'font-normal text-[#000000] opacity-60 text-sm',
};

export const blockedCarriers = {
  blockedContainer: 'text-[#000000] text-[12px] font-medium py-3 mb-2',
  noCarrierCotainer: 'mt-2!',
  noCarrierText:
    'bg-[#ccc] p-[10px] rounded-xs text-[#000000] text-[12px] font-medium',
  carrierMcDotText: 'font-normal text-[#000000] opacity-60 text-sm',
  carrierLTLBox:
    'bg-[#248670] font-light! text-white text-sm! rounded-sm flex justify-center items-center',
};

export const customerSettingAndAlert = {
  mainText: 'text-[#000000] text-[12px] font-medium py-2 mt-1',
  dividerStyle: 'mr-3! mt-1!',
  checkboxContainer: 'flex! flex-col! min-w-0!',
  emailDivider: 'py-1!',
};

export const defaultMargin = {
  mainText: 'text-[#000000] text-[12px] font-medium py-2',
  defaultText: 'mt-2 mb-1 text-[16px] font-normal text-[#123B50]',
  itemsStyle: 'text-[#000000] text-[14px] font-bold opacity-80',
  itemsContainerSpace: 'mt-3! mb-3!',
  itemsPadding: 'p-1!',
  dividerStyle: 'pt-2! pb-1!',
  switchContainer: 'py-2! ml-3!',
  switchButtonContainer: 'flex! items-center! flex-wrap!',
  blackText: 'text-[#000000]',
  greyText: 'text-[#606060]',
};

export const ltlComponent = {
  buttonStyle: 'w-[17px]!',
  expandButton: 'bg-[#ccc]! text-black! ml-[10px]!',
};

export const CustomerSpecificPricing = {
  container: 'text-[#000000] text-[12px] font-medium py-3 mb-2',
  noCarrierContainer: 'mt-2!',
  noCarrierText:
    'bg-[#ccc] p-[10px] rounded-xs text-[#000000] text-[12px] font-medium',
  carrierDetailsText: 'font-normal text-[#000000] opacity-60 text-sm',
  carrierLTLBox:
    'bg-[#248670] font-light! text-white text-sm! rounded-sm flex justify-center items-center',
};

export const AlternateCustomer = {
  container: 'text-[#000000] text-[12px] font-medium py-3 mb-2',
  noCustomerContainer: 'mt-2!',
  noCustomerText:
    'bg-[#ccc] p-[10px] rounded-xs text-[#000000] text-[12px] font-medium',
  customerDetailsText: 'font-normal text-[#000000] opacity-60 text-sm',
  customerLTLBox:
    'bg-[#248670] font-light! text-white text-sm! rounded-sm flex justify-center items-center',
};
export const TestLaneFormDataClasses = {
  selectedValueBox: 'bg-[#dff0d8]! flex gap-1 p-1 items-center text-xs',
  selectedValueIcon: 'text-base!',
};
